import React from "react";
import BackButton from "../common/BackButton";
import Tabs from "../Tabs.js";
import PitchSlider2 from "../conversion/PitchSlider2";
import AutotuneSelector from "../conversion/AutotuneSelector";
import VolumeSlider from "../conversion/VolumeSlider";
import CreatorBadge from "../CreatorBadge";
import { Button, Checkbox } from "@jammable/ui-core";
import { Input } from "@jammable/ui-components/Forms";

const ConversionSettingsView = ({
  // New Props
  settings,
  dispatchSettings,

  // Other Props
  selectedVoices,
  notCreator,

  // Handlers
  onBack,
}) => {
  const tabsData = [
    { id: "basic", label: "Basic" },
    { id: "advanced", label: "Advanced" },
  ];

  return (
    <div className="tw-p-5">
      {/* Back Button and Title */}
      <div className="tw-flex tw-items-center tw-gap-3 tw-mb-2">
        <BackButton onClick={onBack} aria-label="Back to main create options" />
        <div className="tw-text-xl tw-tracking-widest tw-font-black tw-text-black/40 tw-uppercase">
          Settings
        </div>
      </div>

      <div className="tw-flex tw-flex-col tw-gap-3">
        {/* Tabs */}
        <div className="tw-w-full tw-flex tw-justify-center">
          <Tabs
            tabs={tabsData}
            selectedTab={settings.selectedTab}
            onTabChange={(tabId) =>
              dispatchSettings({ type: "SET_SELECTED_TAB", payload: tabId })
            }
          />
        </div>

        {/* Settings Container - Uncomment CONTENTS */}
        <div className="tw-p-4 tw-bg-gray-100 tw-rounded-3xl tw-flex tw-flex-col tw-gap-2">
          {settings.selectedTab === "basic" ? (
            <>
              {/* Pitch Slider */}
              <div className="tw-mb-1 tw-bg-white tw-p-3 tw-rounded-2xl tw-px-4">
                <PitchSlider2
                  voices={selectedVoices}
                  pitchScaling={settings.pitchScaling}
                  dispatchSettings={dispatchSettings}
                />
              </div>
              {/* Autotune */}
              <AutotuneSelector
                autotune={settings.autotune}
                dispatchSettings={dispatchSettings}
              />
              {/* Add Effects Checkbox */}
            </>
          ) : (
            <>
              {/* Volume Slider */}
              <div className="tw-mb-1 tw-bg-white tw-p-3 tw-rounded-2xl tw-px-4">
                <VolumeSlider
                  voiceVolume={settings.voiceVolume}
                  onValueChange={(value) =>
                    dispatchSettings({
                      type: "SET_VOICE_VOLUME",
                      payload: value,
                    })
                  }
                />
              </div>

              {/* Advanced Checkboxes Container */}
              <div className="tw-bg-white tw-rounded-2xl tw-p-3 tw-flex tw-flex-col tw-gap-3">
                {/* Extract Background */}
                <div className="tw-flex tw-items-center tw-gap-2 tw-cursor-pointer">
                  <Checkbox
                    checked={settings.extractBackground}
                    onCheckedChange={(checked) =>
                      dispatchSettings({
                        type: "SET_EXTRACT_BACKGROUND",
                        payload: checked,
                      })
                    }
                  />
                  <div
                    onClick={() =>
                      dispatchSettings({
                        type: "SET_EXTRACT_BACKGROUND",
                        payload: !settings.extractBackground,
                      })
                    }
                  >
                    <div className="tw-text-sm tw-font-semibold">
                      Extract Background Vocals
                    </div>
                    <div className="tw-text-xs tw-text-black/40 tw-text-wrap">
                      Use this if your original input contains background vocals
                      for a cleaner output.{" "}
                    </div>
                  </div>
                </div>
                {/* Skip Extraction */}
                <div className="tw-flex tw-items-center tw-gap-2 tw-cursor-pointer">
                  <Checkbox
                    checked={settings.skipExtraction}
                    onCheckedChange={(checked) =>
                      dispatchSettings({
                        type: "SET_SKIP_EXTRACTION",
                        payload: checked,
                      })
                    }
                  />
                  <div
                    onClick={() =>
                      dispatchSettings({
                        type: "SET_SKIP_EXTRACTION",
                        payload: !settings.skipExtraction,
                      })
                    }
                  >
                    <div className="tw-text-sm tw-font-semibold">
                      Skip Vocal Extraction
                    </div>
                    <div className="tw-text-xs tw-text-black/40 tw-text-wrap">
                      Use this if your original input is already isolated.
                      vocals.
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>

        {/* Rename Input */}
        <Input
          aria-label="Optional Conversion Name"
          value={settings.name}
          onChange={(e) =>
            dispatchSettings({ type: "SET_NAME", payload: e.target.value })
          }
          className="tw-h-12 tw-bg-gray-100 tw-font-light tw-rounded-2xl"
          placeholder="Rename (optional)..."
        />
      </div>

      {/* Done Button */}
      <Button
        onClick={onBack}
        className="tw-mt-4 tw-w-full tw-text-lg tw-uppercase tw-rounded-2xl tw-font-black tw-h-12 tw-border tw-border-solid tw-border-purple-700 tw-border-b-4 tw-border-b-purple-900 active:tw-translate-y-0.5 active:tw-border-b-2 active:tw-scale-[0.98] tw-transition tw-duration-100 tw-ease-in-out disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
      >
        Done
      </Button>
    </div>
  );
};

export default ConversionSettingsView;
